<div *ngFor="let lang of language" (click)="change(lang)">
  <a mat-menu-item>{{lang.name}}</a>
  <div class="divider"></div>
</div>
